import { Component, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AdminService } from '../../services/admin.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IDepartment } from '../../interfaces/models/admin.model';
import { InputTextModule } from 'primeng/inputtext';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { SectionComponent } from '../section/section.component';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DirectionService } from '../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-department',
  standalone: true,
  imports: [ButtonModule, TranslateModule, CommonModule, ReactiveFormsModule, FormsModule, TableModule, SectionComponent, InputTextModule, ConfirmPopupModule, DropdownModule, NavTitlePipe],
  templateUrl: './department.component.html',
  styleUrl: './department.component.scss',
  providers: [ConfirmationService],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: '0', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0', opacity: 0 }))
      ])
    ])
  ]
})
export class DepartmentComponent implements OnInit {

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('departmentForm') dpartmentForm!: FormGroup;
  isModalVisible = false;
  isDeleteDepartmentModalVisible = false;
  selectedDepartment = {} as IDepartment;
  selectedDepartmentModal = {} as IDepartment;
  isModalSubmitted = false;
  currentDepartmentDeletionPreview = {} as any
  unitProjects = [] as any[]
  unitProjectsForm!: FormGroup;
  employeeForm!: FormGroup;
  //dropdown
  selectedDepartmentId = 0;
  departments = [] as Partial<IDepartment>[]
  filteredDepartments = [] as Partial<IDepartment>[]
  searchTerm = '';
  employees = [] as any[];
  departmentOptions = [] as { label: string, id: number }[];
  userOptions = [] as { label: string, id: number }[];
  dir!: 'rtl' | 'ltr';
  isEmployeeDeletable = false;
  activeMenuId: number | null = null;
  isDepartmentsSectionOpen: boolean = true;
  isSectionsSectionOpen: boolean = true;

  today!: Date;
  constructor(
    private adminService: AdminService,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private directionService: DirectionService
  ) {
  }
  ngOnInit(): void {
    this.today = new Date();
    
    // Initialize forms to prevent errors
    this.unitProjectsForm = new FormGroup({});
    this.employeeForm = new FormGroup({});
    
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    this.adminService.getListDepartments().subscribe((response: any) => {
      this.departments = response['data']['departments'] as IDepartment[]
      this.selectedDepartmentId = 0;
      this.selectedDepartment = {} as IDepartment;
      this.onSearch();

      this.departmentOptions = this.departments.map(x => {
        return { label: x.name, id: x.id } as { label: string, id: number }
      })
    })
    
    // Load users for in_charge dropdown
    this.adminService.getListUsers().subscribe((response: any) => {
      const users = response['data']['users'] || [];
      this.userOptions = users.map((user: any) => ({
        label: user.name,
        id: user.id
      }));
    })
  }

  openDepartmentModal(departmentId: number) {
    if (departmentId == 0) {
      this.selectedDepartmentModal = {} as IDepartment;
    } else {
      this.selectedDepartmentModal = structuredClone(this.departments.find(x => x.id == departmentId) as IDepartment);
    }
    this.isModalSubmitted = false;
    this.isModalVisible = true;
  }

  onSearch() {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      this.filteredDepartments = [...this.departments];
      return;
    }
    this.filteredDepartments = this.departments.filter((dept) =>
      [dept.name, dept.in_charge_name]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .includes(term)
    );
  }

  clearSearch() {
    this.searchTerm = '';
    this.onSearch();
  }

  getTotalSectionsCount(): number {
    return (this.departments || []).reduce((sum, d) => sum + (d.sections?.length || 0), 0);
  }

  getAssignedManagersCount(): number {
    return (this.departments || []).filter((d) => !!d.in_charge_name || !!d.in_charge_id).length;
  }
  closeDepartmentModal() {
    this.isModalVisible = false;
  }
  submit() {
    this.isModalSubmitted = true;
    if (this.dpartmentForm.valid && !this.selectedDepartmentModal.id) {
      this.adminService.createDepartments({ 
        name: this.selectedDepartmentModal.name,
        in_charge_id: this.selectedDepartmentModal.in_charge_id 
      }).subscribe((response: any) => {
        this.toastr.success("تمت الاضافة ", "عملية ناجحة");
        const newDept = { 
          name: this.selectedDepartmentModal.name, 
          id: response['data']['entity']['id'],
          in_charge_id: this.selectedDepartmentModal.in_charge_id,
          in_charge_name: this.userOptions.find(u => u.id === this.selectedDepartmentModal.in_charge_id)?.label
        };
        this.departments.push(newDept)
        this.departmentOptions.push({ label: this.selectedDepartmentModal.name, id: response['data']['entity']['id'] })
        this.selectedDepartment = newDept as IDepartment;
        this.isModalSubmitted = false;
        this.selectedDepartmentModal = {} as IDepartment;
        this.selectedDepartmentId = response['data']['entity']['id'];
        this.dpartmentForm.reset();
        this.isModalVisible = false;
        this.onSearch();
      })
    }
    else if (this.dpartmentForm.valid && this.selectedDepartmentModal.id > 0) {

      this.adminService.updateDepartments(this.selectedDepartmentModal.id, { 
        name: this.selectedDepartmentModal.name,
        in_charge_id: this.selectedDepartmentModal.in_charge_id 
      }).subscribe((response: any) => {
        this.toastr.success("تم التعديل ", "عملية ناجحة");
        const updatedDept = { 
          ...this.selectedDepartmentModal,
          in_charge_name: this.userOptions.find(u => u.id === this.selectedDepartmentModal.in_charge_id)?.label
        };
        this.departments = this.departments.map(x => {
          if (x.id == this.selectedDepartmentModal.id) {
            this.selectedDepartment = { ...x, ...updatedDept };
            return { ...x, ...updatedDept }
          } else {
            return x;
          }
        })
        this.isModalVisible = false;
        this.isModalSubmitted = false;
        this.dpartmentForm.reset();
        this.onSearch();
      })
    }
    else {
      this.toastr.error("يرجي مراجعة البيانات", "فشل");
    }
  }

  // Delete from modal (direct call)
  confirmDepartmentDelete(event: Event, departmentId: number) {
    this.adminService.deleteDepartments(departmentId).subscribe({
      next: () => {
        this.selectedDepartment = {} as IDepartment;
        this.departments = this.departments.filter(x => x.id != departmentId);
        this.departmentOptions = this.departmentOptions.filter(x => x.id != departmentId);
        this.selectedDepartmentId = 0;
        this.onSearch();
        this.toastr.success(this.dir == 'rtl' ? "تم المسح بنجاح" : "Deleted successfully", this.dir == 'rtl' ? "عملية ناجحة" : "Success");
        this.isDeleteDepartmentModalVisible = false;
      },
      error: (err) => {
        console.error('Delete Department Error:', err);
        const errorMsg = err?.error?.error?.message || err?.error?.message || (this.dir == 'rtl' ? 'حدث خطأ أثناء الحذف' : 'Error occurred during deletion');
        this.toastr.error(errorMsg, this.dir == 'rtl' ? "فشل" : "Failed");
      }
    })
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  dpartmentChange() {
    this.selectedDepartment = { ...this.departments.find(x => x.id == this.selectedDepartmentId) as IDepartment }
  }
  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length;
  }
  openDeleteDepartmentModal(departmentId: number) {
    this.isDeleteDepartmentModalVisible = true;
    this.selectedDepartmentId = departmentId;


    this.adminService.getDepartmentDeletionPreview(departmentId).subscribe((response: any) => {
      this.currentDepartmentDeletionPreview = response['data'];

      this.unitProjects = Object.values(this.currentDepartmentDeletionPreview['strategiesWithProjects']).reduce((acc: any[], curr: any) => {
        const mapped = curr.projects.map((x: any) => {
          return { "strategy_name": curr.strategy_name, ...x, filteredInChargeExecutives: x.inChargeExecutives }
        })

        return [...acc, ...mapped]
      },
        [] as any[]
      )
      this.isEmployeeDeletable = !this.unitProjects.length;
      const employeeGroupControls = {} as any;
      if (this.isEmployeeDeletable) {
        this.employees = this.currentDepartmentDeletionPreview.employees.map((x: any) => {
          return {
            ...x,
            departments: this.currentDepartmentDeletionPreview.departmentsForSelect,
            sections: this.currentDepartmentDeletionPreview.sectionsForSelect,
            filterdSections: this.currentDepartmentDeletionPreview.sectionsForSelect,
            roles: this.currentDepartmentDeletionPreview.rolesForSelect,
          }

        })
        this.employees.forEach((employee, index) => {
          employeeGroupControls[index] = new FormGroup({
            id: new FormControl(employee.id),
            department_id: new FormControl(''),
            section_id: new FormControl('', Validators.required),
            role: new FormControl('', Validators.required),

          });


          employeeGroupControls[index].get('department_id')
            ?.valueChanges.subscribe((departmentId: string) => {
              const departmentSections = this.currentDepartmentDeletionPreview.departmentSectionsMap[departmentId]
              this.employees[index].filterdSections = this.employees[index].sections.filter((x: any) => departmentSections.includes(x.id))
            });
        });
        this.employeeForm = new FormGroup(employeeGroupControls);
      }





      const groupControls = {} as any;
      this.unitProjects.forEach((project, index) => {
        groupControls[index] = new FormGroup({
          project_id: new FormControl(project.id),
          entity_in_charge_type: new FormControl(''),
          entity_in_charge_id: new FormControl('', Validators.required),
          executive_in_charge_id: new FormControl('', Validators.required),

        });
        groupControls[index].get('entity_in_charge_id')
          ?.valueChanges.subscribe((entityInchargeValue: string) => {



            const [entity_in_charge_type, entity_in_charge_id] = entityInchargeValue?.split('-')
            const formGroup = this.unitProjectsForm.get(String(index)) as FormGroup;
            const entity_in_charge_id_control = formGroup.get('entity_in_charge_id') as FormControl;
            const entity_in_charge_type_control = formGroup.get('entity_in_charge_type') as FormControl;
            entity_in_charge_id_control.setValue(+entity_in_charge_id);
            entity_in_charge_type_control.setValue(entity_in_charge_type);


            const unitEmployees = this.currentDepartmentDeletionPreview.unitEmployeesMap[entityInchargeValue]

            this.unitProjects[index].filteredInChargeExecutives = this.unitProjects[index].inChargeExecutives.filter((x: any) => unitEmployees.includes(x.id))


          });
      });
      this.unitProjectsForm = new FormGroup(groupControls);
    });



















  }
  onProjectTransferSubmit() {
    const payload = { "projects": Object.values(this.unitProjectsForm.value) }
    this.adminService.transferDepartmentProjects(this.selectedDepartmentId, payload).subscribe((response: any) => {
      this.isEmployeeDeletable = true;
      this.unitProjects = [];
      this.toastr.success(response['data']['message'])
    })


  }
  onEmployeeTransferSubmit() {
    const payload = { "employees": Object.values(this.employeeForm.value) }
    this.adminService.transferDepartmentEmployees(this.selectedDepartmentId, payload).subscribe((response: any) => {
      this.employees = []
      this.toastr.success(response['data']['message'])
    })
  }
  closeDeleteModal() {
    this.isDeleteDepartmentModalVisible = false;
  }
  
  toggleMenu(event: Event, departmentId: number) {
    event.stopPropagation();
    this.activeMenuId = this.activeMenuId === departmentId ? null : departmentId;
  }

  closeMenu() {
    this.activeMenuId = null;
  }

  closeAllMenus() {
    this.activeMenuId = null;
  }
  
  selectDepartment(departmentId: number) {
    this.selectedDepartmentId = departmentId;
    this.selectedDepartment = { ...this.departments.find(x => x.id == departmentId) as IDepartment };
    this.isSectionsSectionOpen = true;
    setTimeout(() => {
      document.getElementById('sections-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
  
  toggleDepartmentsSection() {
    this.isDepartmentsSectionOpen = !this.isDepartmentsSectionOpen;
  }
  
  toggleSectionsSection() {
    this.isSectionsSectionOpen = !this.isSectionsSectionOpen;
  }


}



